import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import guardAuthService from '../services/guardAuth.service';

interface Props {
  children: React.ReactElement;
}

export default function GuardPrivateRoute({ children }: Props) {
  const location = useLocation();
  if (!guardAuthService.isAuthenticated()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
